import classNames from 'classnames';
import { observer } from 'mobx-react';

import IconButton from '../../../../../../../shared/components/Button/IconButton';
import Icon from '../../../../../../../shared/components/Icon/Icon';
import ModularConfiguratorCoordinatorState from '../../../../ModularConfiguratorCoordinatorState';
import css from './ModularComponentActionButtons.css';

interface ModularComponentToolbarActionsProps {
  state: ModularConfiguratorCoordinatorState;
  className?: string;
}

const ModularComponentActionButtons = observer(({ className, state }: ModularComponentToolbarActionsProps) => {
  const handleMoveButtonClick = () => {
    if (state.configurator.isMoveActionActive) {
      state.configurator.activateDefaultAction();
    } else {
      state.configurator.activateMoveAction();
    }
  };

  const handleRotateButtonClick = () => {
    if (state.configurator.isRotateActionActive) {
      state.configurator.activateDefaultAction();
    } else {
      state.configurator.activateRotateAction();
    }
  };

  return (
    <div className={classNames(css.container, className)}>
      {/* These features are currently disabled for users and are kept for internal use only. */}
      {/*<ToolbarButton*/}
      {/*  icon="trash"*/}
      {/*  tooltip={{ id: 'modular-component-2d-action', text: 'Remove' }}*/}
      {/*  onClick={state.configurator.removeSelectedComponent}*/}
      {/*  compact*/}
      {/*/>*/}
      {/*<ToggleButton*/}
      {/*  id="modular-component-move-action"*/}
      {/*  label="Move"*/}
      {/*  icon="move"*/}
      {/*  onClick={handleMoveButtonClick}*/}
      {/*  isPressed={state.configurator.isMoveActionActive}*/}
      {/*/>*/}
      {/*<ToggleButton*/}
      {/*  id="modular-component-rotate-action"*/}
      {/*  label="Rotate"*/}
      {/*  icon="rotate"*/}
      {/*  onClick={handleRotateButtonClick}*/}
      {/*  isPressed={state.configurator.isRotateActionActive}*/}
      {/*/>*/}
      <IconButton
        type="button"
        className={css.applyButton}
        icon={<Icon className={css.icon} name="fill" />}
        onClick={state.configurator.applySelectedComponentConfiguration}
      >
        Apply style to other elements
      </IconButton>
    </div>
  );
});

export default ModularComponentActionButtons;
